export const MATCH_RULES_FIELD_NAME_BUDGET_GATE = 'budget_is_hard'

export const MATCH_RULES_FIELD_NAME_CRITERIA = 'criteria'

export const MATCH_RULES_FIELD_NAME_GATING = 'gating'

export const MATCH_RULES_FIELD_NAME_WEIGHTS = 'weights'

export const MATCH_RULES_PREVIEW_DELAY = 400

export const MATCH_RULES_GATING_FIELD = {
  maxOccupancy: 'max_occupancy',
  minOccupancy: 'min_occupancy',
  petsPolicy: 'pets_policy',
  wbsRequired: 'wbs_required',
}

export const MATCH_RULES_GATING_CRITERION = {
  household: 'household',
  pets: 'pets',
  wbs: 'wbs',
}

export const MATCH_RULES_CRITERION_UNIT_KEY = {
  [MATCH_RULES_GATING_CRITERION.household]:
    'RentalPortal.MatchRulesOccupancyUnitKey',
}

export const MATCH_RULES_PETS_POLICY = {
  allowed: 'allowed',
  notAllowed: 'not_allowed',
  onRequest: 'on_request',
}

export const MATCH_RULES_PETS_POLICY_LABEL_KEY = {
  [MATCH_RULES_PETS_POLICY.allowed]: 'RentalPortal.MatchRulesPetsAllowedKey',
  [MATCH_RULES_PETS_POLICY.notAllowed]:
    'RentalPortal.MatchRulesPetsNotAllowedKey',
  [MATCH_RULES_PETS_POLICY.onRequest]:
    'RentalPortal.MatchRulesPetsOnRequestKey',
}

export const MATCH_RULES_RANGE_SEPARATOR = '–'

export const MATCH_RULES_BUDGET_CRITERION = 'budget'

export const MATCH_RULES_COLUMN_TITLE_KEYS = [
  'RentalPortal.MatchRulesColumnCriterionKey',
  'RentalPortal.MatchRulesColumnListingKey',
  'RentalPortal.MatchRulesColumnWeightKey',
]

export const MATCH_RULES_ADDED_CRITERION = {
  gates_eligibility: false,
  listing_value: null,
  measure_detail: null,
}

export const MATCH_RULES_GATING_CHANGE = {
  [MATCH_RULES_GATING_FIELD.maxOccupancy]: {
    criterion: MATCH_RULES_GATING_CRITERION.household,
    qualifierKey: 'RentalPortal.MatchRulesOccupancyMaxKey',
  },
  [MATCH_RULES_GATING_FIELD.minOccupancy]: {
    criterion: MATCH_RULES_GATING_CRITERION.household,
    qualifierKey: 'RentalPortal.MatchRulesOccupancyMinKey',
  },
  [MATCH_RULES_GATING_FIELD.petsPolicy]: {
    criterion: MATCH_RULES_GATING_CRITERION.pets,
  },
  [MATCH_RULES_GATING_FIELD.wbsRequired]: {
    criterion: MATCH_RULES_GATING_CRITERION.wbs,
  },
}

export const MATCH_RULES_SAVE_ERROR_KEY = {
  insufficient_scored_criteria:
    'RentalPortal.MatchRulesInsufficientScoredErrorKey',
}

export const MATCH_RULES_OCCUPANCY_MAX = 20

export const MATCH_RULES_OCCUPANCY_MIN = 1

export const MATCH_RULES_WEIGHT_MAX = 100

export const MATCH_RULES_WEIGHT_MIN = 0

export const MATCH_RULES_PARAM = 'rules'

export const MATCH_RULES_PARAM_OPEN = 'open'

export const QA_NAME_MATCH_RULES_BUTTON = 'matchRulesButton'

export const QA_NAME_MATCH_RULES_MODAL = 'matchRulesModal'

export const QA_NAME_MATCH_RULES_ROW = 'matchRulesRow'

export const QA_NAME_MATCH_RULES_IMPACT = 'matchRulesImpact'

export const QA_NAME_MATCH_RULES_ADD_CRITERION = 'matchRulesAddCriterion'

export const QA_NAME_MATCH_RULES_GATING_VALUE = 'matchRulesGatingValue'
